import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { GetServiceSetData } from "../../../../../Api/ServiceDatas";
import LineBtn from "../../../../Button/LineBtn";
import DotStatus from "../../../../DefaultStyles/DotStatus";
import Flex from "../../../../DefaultStyles/Flex";
import LineBox from "../../../../DefaultStyles/LineBox";
import TempAccountModal, { tempAccountModalState } from "./TempAccountModal";
import Table, { TableBody, TableBodyItem } from "../../../../Table/Table";
import { useApi } from "../../../../../hooks/useApi";

export interface IAccountInfo {
  id: number;
  servsubsid: number;
  type: string;
  email: string;
  pw: string;
  pin: string;
  partyid: string[];
  duedate: string;
  comment: string;
  admin: string;
  update: string;
  pay?: string;
}

interface TempAccountProps extends IAccountInfo {
  adminId: number;
  servid: number;
}

export default function TempAccount() {
  const navigate = useNavigate();

  const [tempAccountModalStateValue, setTempAccountModalStateValue] =
    useRecoilState(tempAccountModalState);
  const [addTempAccountModal, setAddTempAccountModal] = useState(false);
  const [tempAccountModal, setTempAccountModal] = useState(false);
  const [accountInfo, setAccountInfo] = useState<IAccountInfo>({
    id: 0,
    servsubsid: 0,
    type: "",
    email: "",
    pw: "",
    pin: "",
    partyid: [],
    duedate: "",
    comment: "",
    admin: "",
    update: "",
    pay: "",
  });

  const { response, fetchData } = useApi({
    method: "get",
    url: `temp-account`,
  });

  const tempAccountTableHeader = [
    "서비스",
    "로그인 수단",
    "계정",
    "비밀번호",
    "정보 갱신일시",
    "상태",
    "대여 정보 PID(UID)",
    "대여 만료일",
    "비고",
    "상세",
  ];

  return (
    <>
      <Flex style={{ justifyContent: "flex-end", marginBottom: 12 }}>
        <LineBtn
          btnText="임시 계정 추가"
          icon="add"
          btnClickEvent={() => {
            setTempAccountModalStateValue({
              ...tempAccountModalStateValue,
              servsubsid: 0,
            });
            setAddTempAccountModal(true);
          }}
        />
      </Flex>

      <LineBox>
        <Table tableHeadData={tempAccountTableHeader} tableMinWidth={700}>
          <>
            {response?.data?.map((d: TempAccountProps, index: number) => {
              const objByDetail = d?.partyid.reduce(
                (group: any, product: any) => {
                  const pid = product?.split("_")[0] ?? "";

                  group[pid] = group[pid] ?? [];
                  group[pid].push(
                    `${product?.split("_")[1]}_${product?.split("_")[2]}`
                  );

                  return group;
                },
                {}
              );

              const arrByDetail = Object.entries(objByDetail) as [
                string,
                string[]
              ][];

              return (
                <TableBody key={index}>
                  <TableBodyItem style={{ wordBreak: "keep-all" }}>
                    {GetServiceSetData(d?.servid)[0]?.SVC_NMKR_TEMP}_{d?.id}
                  </TableBodyItem>
                  <TableBodyItem>
                    {d?.type !== "" ? d?.type ?? "-" : "-"}
                  </TableBodyItem>
                  <TableBodyItem>{d?.email ?? "-"}</TableBodyItem>
                  <TableBodyItem>{d?.pw ?? "-"}</TableBodyItem>
                  <TableBodyItem>{d?.update}</TableBodyItem>
                  <TableBodyItem>
                    <DotStatus
                      text={arrByDetail?.length > 0 ? "대여중" : "대여 가능"}
                      color={arrByDetail?.length > 0 ? "#ffb128" : "#00c7c7"}
                      size="sm"
                    />
                  </TableBodyItem>
                  <TableBodyItem>
                    {arrByDetail?.length > 0
                      ? arrByDetail?.map((data, index: number) => {
                          const uidList = data[1] as string[];

                          return (
                            <div
                              key={index}
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                navigate(`/party/info/${data[0] ?? 0}`)
                              }
                            >
                              {data[0]}(
                              {uidList?.map(
                                (d: string, i: number) =>
                                  `${d?.split("_")[0]}` +
                                  (i + 1 === uidList?.length ? `` : `,`)
                              )}
                              )
                            </div>
                          );
                        })
                      : "-"}
                  </TableBodyItem>
                  <TableBodyItem>{d?.duedate ?? "-"}</TableBodyItem>
                  <TableBodyItem style={{ wordBreak: "keep-all" }}>
                    {d?.comment !== "" ? d?.comment ?? "-" : "-"}
                  </TableBodyItem>
                  <TableBodyItem>
                    <LineBtn
                      btnText="상세"
                      btnClickEvent={() => {
                        setTempAccountModal(true);
                        setAccountInfo({
                          id: Number(d?.id),
                          servsubsid: d?.servsubsid ?? 0,
                          type: d?.type ?? "",
                          email: d?.email ?? "",
                          pw: d?.pw ?? "",
                          pin: d?.pin ?? "",
                          partyid: d?.partyid ?? [],
                          duedate: d?.duedate ?? "",
                          comment: d?.comment ?? "",
                          admin: `${d?.adminId}_${d?.admin}`,
                          update: d?.update,
                          pay: d?.pay ?? "",
                        });
                      }}
                    />
                  </TableBodyItem>
                </TableBody>
              );
            })}
          </>
        </Table>
      </LineBox>

      {(addTempAccountModal || tempAccountModal) && (
        <TempAccountModal
          closeEvent={() => {
            if (addTempAccountModal) {
              setAddTempAccountModal(false);
            } else {
              setTempAccountModal(false);
            }
          }}
          confirmEvent={() =>
            fetchData({
              method: "get",
              url: `temp-account`,
            })
          }
          accountInfo={tempAccountModal ? accountInfo : undefined}
          type={addTempAccountModal ? "input" : "view"}
        />
      )}
    </>
  );
}
